import React from 'react'
import { LanguageProvider } from '../lib'

export default ({ element }, opts) => {
  const { defaultLanguage, translations, availableLanguages } = opts

  return (
    <LanguageProvider
      data={{
        translations,
        language: defaultLanguage,
        availableLanguages: availableLanguages || Object.keys(translations)
      }}
    >
      {element}
    </LanguageProvider>
  )
}
